import Vue from "vue";
import observer from "vue-mutation-observer";

Vue.use(observer as any);
